import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    title: 'Session expired',
    description: 'Close the app and open it again from the chat — the session will be renewed.',
    action: 'Close app',
  },
  ru: {
    title: 'Сессия устарела',
    description: 'Закрой приложение и открой его заново из чата — сессия обновится.',
    action: 'Закрыть приложение',
  },
  uz: {
    title: 'Sessiya eskirdi',
    description: 'Ilovani yoping va chatdan qaytadan oching — sessiya yangilanadi.',
    action: 'Ilovani yopish',
  },
  fa: {
    title: 'نشست منقضی شد',
    description: 'برنامه را ببند و دوباره از چت بازش کن — نشست تازه می‌شود.',
    action: 'بستن برنامه',
  },
  pt: {
    title: 'A sessão expirou',
    description: 'Feche o app e abra de novo pelo chat — a sessão será renovada.',
    action: 'Fechar app',
  },
  tr: {
    title: 'Oturum süresi doldu',
    description: 'Uygulamayı kapat ve sohbetten yeniden aç — oturum yenilenir.',
    action: 'Uygulamayı kapat',
  },
});
